import LegalLayout, { LegalSection } from "./LegalLayout";
import { SITE } from "@/config/site";

export default function TermsPage() {
  return (
    <LegalLayout title="Terms of Service" lastUpdated="December 2025" testId="terms-page">
      <p className="text-lg font-light leading-relaxed text-[#15243D]">
        By using this site, purchasing the 28-day program, or entering a 1:1
        coaching relationship with Anchor, you agree to the terms below. They
        are written in plain language and meant to be read.
      </p>

      <LegalSection n="01" title="Who we are">
        <p>
          Anchor is the coaching and personal-development work of Ben (sole
          proprietor). The site is operated from the United States.
        </p>
      </LegalSection>

      <LegalSection n="02" title="What Anchor is — and is not">
        <p>
          Anchor offers coaching, written practices, and audio reflections.
          This work is <span className="text-[#15243D]">not</span> a
          replacement for medical, psychological, psychiatric, or therapeutic
          care. It is not a substitute for advice from a licensed clinician.
        </p>
        <p>
          If you are in crisis, experiencing thoughts of harm, or living with
          a diagnosed mental-health condition that requires clinical support,
          please contact a qualified professional or emergency services.
        </p>
      </LegalSection>

      <LegalSection n="03" title="Your responsibility">
        <p>
          You are responsible for your own decisions, well-being, and
          actions before, during, and after participating in any Anchor work.
          The reflections and practices offered here are invitations — what
          you do with them is yours to choose.
        </p>
      </LegalSection>

      <LegalSection n="04" title="The 28-day program">
        <p>
          The 28-day program is a one-time purchase delivering written
          reflections (text edition) and audio companions as they become
          available (founding-member audio edition).
        </p>
        <p>
          <span className="text-[#15243D]">Refunds:</span> if the program is
          not what you expected, email us within 14 days of purchase for a
          full refund. After 14 days, all sales are final.
        </p>
        <p>
          <span className="text-[#15243D]">Use:</span> the program is licensed
          for personal use. Please do not redistribute, republish, or resell
          the materials.
        </p>
      </LegalSection>

      <LegalSection n="05" title="1:1 coaching">
        <p>
          1:1 coaching is offered in a 4–6 week container. The specific
          structure, number of sessions, and schedule are agreed in your
          onboarding conversation and recorded inside the signed coaching
          agreement.
        </p>
        <p>
          <span className="text-[#15243D]">Sessions & rescheduling:</span>{" "}
          sessions begin and end on time. Rescheduling requires 24 hours’
          notice. Sessions missed without notice may be forfeited.
        </p>
        <p>
          <span className="text-[#15243D]">Payment:</span> coaching is paid in
          full ($2,000) or in two monthly installments ($1,050 × 2). Failed
          payments may pause the coaching relationship until resolved.
        </p>
        <p>
          <span className="text-[#15243D]">Refunds:</span> coaching is
          generally non-refundable once your container has begun. If
          unforeseen circumstances make continuation impossible, we will
          discuss a fair, pro-rated resolution in good faith.
        </p>
      </LegalSection>

      <LegalSection n="06" title="Payments">
        <p>
          All payments are processed by Stripe. Charges appear on your
          statement as a Stripe transaction. We do not see or store your card
          details.
        </p>
      </LegalSection>

      <LegalSection n="07" title="Intellectual property">
        <p>
          All content on this site — written reflections, the 28-day program,
          audio recordings, the Anchor name and mark — is the property of
          Anchor. You may share short quotations with attribution. You may
          not republish, repackage, or sell any of it.
        </p>
      </LegalSection>

      <LegalSection n="08" title="Limitation of liability">
        <p>
          To the maximum extent allowed by law, Anchor and Ben are not liable
          for any indirect, incidental, or consequential damages arising from
          your use of this site or participation in any Anchor offering. Our
          total liability for any claim related to a purchase is limited to
          the amount you paid for that specific purchase.
        </p>
      </LegalSection>

      <LegalSection n="09" title="Governing law">
        <p>
          These terms are governed by the laws of the United States and, where
          applicable, the state in which Anchor’s sole proprietor resides.
          Disputes will be resolved in good faith first; if they cannot be
          resolved that way, in the appropriate courts of that jurisdiction.
        </p>
      </LegalSection>

      <LegalSection n="10" title="Changes">
        <p>
          If these terms change, we’ll update the “last updated” date above.
          Active coaching clients will be notified by email if changes
          materially affect their engagement.
        </p>
      </LegalSection>

      <LegalSection n="11" title="Contact">
        <p>
          Questions or concerns — write to{" "}
          <a
            href={`mailto:${SITE.contactEmail}`}
            className="text-[#C07865] hover:text-[#A66352] underline-offset-4"
          >
            {SITE.contactEmail}
          </a>
          .
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
